import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-analytics-dashboard',
  templateUrl: './analytics-dashboard.component.html',
  styleUrls: ['./analytics-dashboard.component.scss']
})
export class AnalyticsDashboardComponent implements OnInit {

  loading = false;
  fromDate = '';
  toDate = '';
  summary: any = null;

  constructor(private http: HttpClient, private toastr: ToastrService) { }

  ngOnInit(): void {
    // Default: last 30 days.
    const today = new Date();
    const from = new Date();
    from.setDate(today.getDate() - 30);
    this.toDate = this.fmt(today);
    this.fromDate = this.fmt(from);
    this.load();
  }

  private fmt(d: Date): string {
    return d.toISOString().substring(0, 10);
  }

  load(): void {
    this.loading = true;
    let url = `${environment.serverUrl}/marketing/analytics/spend`;
    const params: string[] = [];
    if (this.fromDate) { params.push(`fromDate=${this.fromDate}`); }
    if (this.toDate) { params.push(`toDate=${this.toDate}`); }
    if (params.length) { url += '?' + params.join('&'); }

    this.http.get<any>(url).subscribe({
      next: (res) => {
        this.summary = res;
        this.loading = false;
      },
      error: (e) => {
        this.loading = false;
        console.error('Load analytics failed', e);
        this.toastr.error(e?.error?.error || e?.message || 'Failed to load analytics', 'Error');
      }
    });
  }

  get maxDayCost(): number {
    if (!this.summary?.byDay?.length) { return 0; }
    return Math.max(...this.summary.byDay.map((d: any) => d.cost));
  }

  barWidth(cost: number): string {
    const max = this.maxDayCost;
    if (!max) { return '0%'; }
    return Math.max(2, Math.round((cost / max) * 100)) + '%';
  }
}
